
/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const Dashboard = r => require.ensure([], () => r(require('./main')), 'dashboard-bundle')
const CompanyList = r => require.ensure([], () => r(require('./company_list')), 'dashboard-bundle')
const ReportedPluginUsers = r => require.ensure([], () => r(require('./plugin_reported_users')), 'dashboard-bundle')
const WeakestLinkUser = r => require.ensure([], () => r(require('./weakestlinkuser')), 'dashboard-bundle')

export default [
  {
    name: 'dashboard.index',
    path: '/',
    component: Dashboard,
  },
  {
    name: 'pluginusers',
    path: '/reported/pluginusers',
    component: ReportedPluginUsers,
  },
  {
    name: 'dashboard.companylist',
    path: '/companylist',
    component: CompanyList,
  },
  {
    name: 'dashboard.weakestlinkuser',
    path: '/weakestlink',
    component: WeakestLinkUser,
  }
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js